export default [
  {
    path: '/all-colleagues/videos',
    name: 'AllProtocolVideos',
    component: () => import(/* webpackChunkName: "all-colleagues" */ '@/views/from-your-colleagues/'),
  },
  {
    path: '/all-colleagues/questions',
    name: 'AllProtocolVideosQuestions',
    component: () => import(/* webpackChunkName: "all-colleagues" */ '@/views/from-your-colleagues/Questions.vue'),
  },
  {
    path: '/all-colleagues/question/:question',
    name: 'AllProtocolVideosQuestion',
    component: () => import(/* webpackChunkName: "all-colleagues" */ '@/views/from-your-colleagues/Question.vue'),
  },
  {
    path: '/all-colleagues/:speaker',
    name: 'AllProtocolVideosSpeaker',
    component: () => import(/* webpackChunkName: "all-colleagues" */ '@/views/from-your-colleagues/Speaker.vue'),
  },
];
